import { useContext } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { Link, useNavigate } from "react-router-dom";
import { ConnectionStatusContext } from "../../provider/ConnectionStatusProvider";

const AuthDropdown = () => {
  const connectionStatus = useContext(ConnectionStatusContext);
  const navigate = useNavigate();
  const handleSignOut = () => {
    localStorage.removeItem("auth-item");
    connectionStatus?.setAccounts([]);
    connectionStatus?.setBalance([]);
    connectionStatus?.setType("");

    navigate("/");
    // window.location.reload(); // This will refresh the page
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton className="flex items-center rounded-full  text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-primary">
          <div className="h-12 w-12 rounded-full">
            <img
              className="h-full w-full rounded-full object-cover"
              src="/assets/images/user-a.png"
              alt="avatar"
            />
          </div>
        </MenuButton>
      </div>

      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div className="py-1">
          <MenuItem>
            <Link
              to="/dashboard"
              className="block truncate font-semibold px-4 py-2 border-b border-gray-600 text-sm text-gray-200"
            >
              Dashboard
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              to="/twitter-game"
              className="block truncate font-semibold px-4 py-2 border-b border-primary/40 text-sm text-gray-200"
            >
              Twitter game
            </Link>
          </MenuItem>
          {/* <MenuItem>
            <span className="block truncate font-semibold px-4 py-2 border-b border-gray-600 text-sm text-gray-200">
              bc1p9qmmz3697rc56jkj6z74e8cfuq7luh0spylyt7v68957w80676hqu0nda7
            </span>
          </MenuItem>
          <MenuItem>
            <div className="flex items-center gap-1 border-b border-gray-600 py-2 px-4">
              <span className="font-semibold text-sm">BTC: 20.56</span>
              <img
                className="h-6 w-6"
                src="/assets/images/bitcoin.png"
                alt="bitcoin icon"
              />
            </div>
          </MenuItem> */}
          {/* <MenuItem>
            <a
              href="!#"
              className="block px-4 py-2 text-sm text-gray-200 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
            >
              Account settings
            </a>
          </MenuItem> */}
          <MenuItem>
            <button
              type="button"
              onClick={handleSignOut}
              className="block w-full px-4 py-2 text-left text-sm text-gray-200 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
            >
              Sign out
            </button>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  );
};

export default AuthDropdown;
